import { connect } from 'react-redux';

import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';
import { siteUrlsSelector } from '~src/app/selectors/SiteUrlsSelectors';
import { AppState } from '~src/app/state/AppState';
import { MapStateToProps } from '~src/app/utils/ConnectUtils';
import { UserIdentityMigrationBanner, UserIdentityMigrationBannerOwnProps, UserIdentityMigrationBannerStateProps } from '~src/authentication/components/UserIdentityMigrationBanner';

const mapStateToProps: MapStateToProps<UserIdentityMigrationBannerStateProps> = (state: AppState) => ({
    urls: siteUrlsSelector(state),
    isSessionMultiSite: SessionUserSelectors.isSessionMultiSite(state),
    isServerAdmin: SessionUserSelectors.isSessionServerAdmin(state),
});

export const ConnectedUserIdentityMigrationBanner: React.ComponentClass<UserIdentityMigrationBannerOwnProps> =
  connect(mapStateToProps)(UserIdentityMigrationBanner);
